import { idb } from "../db/index.ts";

const fnv = (str: string) => {
	let hash = 0x811c9dc5;
	for (let i = 0; i < str.length; i++) {
		hash ^= str.charCodeAt(i);
		hash = Math.imul(hash, 0x01000193);
	}
	return (hash >>> 0).toString(16).padStart(8, "0");
};

// State checksum used to verify that all clients in a league have converged
// to identical state. Covers what trades can change: player team assignments
// + contracts, and draft pick ownership. Reads the durable store (after a
// flush) rather than the cache so cache-population differences between
// clients can't cause spurious mismatches.
export const rosterChecksum = async () => {
	await idb.cache.flush();
	const players = await idb.league.getAll("players");
	const picks = await idb.league.getAll("draftPicks");
	const teamSeasons = await idb.league.getAll("teamSeasons");

	const playerParts: string[] = [];
	for (const p of [...players].sort((a, b) => a.pid - b.pid)) {
		playerParts.push(
			`${p.pid}:${p.tid}:${p.contract.amount}:${p.contract.exp}`,
		);
	}
	const pickParts: string[] = [];
	for (const dp of [...picks].sort((a, b) => a.dpid - b.dpid)) {
		pickParts.push(`${dp.dpid}:${dp.tid}`);
	}
	// Team records validate that simulated results imported identically
	const recordParts: string[] = [];
	for (const row of [...teamSeasons].sort(
		(a, b) => a.season - b.season || a.tid - b.tid,
	)) {
		recordParts.push(
			`${row.season}:${row.tid}:${row.won}:${row.lost}:${row.tied ?? 0}:${row.otl ?? 0}`,
		);
	}

	const playersHash = fnv(playerParts.join("|"));
	const picksHash = fnv(pickParts.join("|"));
	const recordsHash = fnv(recordParts.join("|"));

	return {
		checksum: fnv(`${playersHash}|${picksHash}|${recordsHash}`),
		players: playersHash,
		picks: picksHash,
		records: recordsHash,
		numPlayers: players.length,
		numPicks: picks.length,
	};
};
